<ng-container>
  @if (showInputForm) {
    <div
      class="bg-[url(/assets/ankaadia_login_background.jpg)] min-h-[100vh] flex items-center justify-center bg-center bg-cover bg-no-repeat"
    >
      <new-ui-guetegemeinschaft-organization-creation
        [message]="message"
        [buttonLabel]="buttonLabel"
        (navigatedBack)="navigatedBack()"
        (organizationCreated)="organizationCreated($event)"
      />
    </div>
  }
</ng-container>
